import { ConnectedHTMLElement } from "./ConnectedHtmlElement.js";

/**
 * @name BaseWin
 * @class BaseWin
 * @extends {ConnectedHTMLElement}
 * @description
 *
 */
export class BaseWin extends ConnectedHTMLElement {
  static observedAttributes = ["player"];
  constructor() {
    super();
  }

  /**
   * @param {SwucState} newState
   * @param {SwucState} oldState
   */
  stateUpdated(newState, oldState) {
    this.render();
  }

  render() {
    const player = this.getAttribute("player");
    if (
      this.state.currentGame === undefined ||
      this.state.currentGame.winner === undefined ||
      this.state.currentGame.winner !== player
    ) {
      this.innerHTML = "";
      return;
    }
    this.innerHTML = `
      <div
        class="bottom-[30px] justify-center items-center flex-col w-full h-auto flex z-50 absolute"
        id="win-overlay"
      >
        <h2 class="text-shadow top-0 font-extrabold text-center absolute font-normal text-4xl">
          Congratulations!<br />You win!
        </h2>
        <img
          alt="You win"
          height="199"
          loading="lazy"
          src="/assets/img/winner-medal.png"
          width="150"
        />
      </div>
      `;
  }

  connectedCallback() {
    this.render();
  }
}
